var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSettings = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Camada 1",
  viewBox: "0 0 100 100",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M88.5 8.87H100v6H88.5zM0 85.12h11.5v6H0zM58 47.66h42v6H58zM69.5 23.74c.13.01.25.01.38.01A11.88 11.88 0 0 0 75.5 1.41a13.017 13.017 0 0 0-1.71-.75A11.756 11.756 0 0 0 69.88 0a11.893 11.893 0 0 0-11.5 8.87H0v6h58.38a11.886 11.886 0 0 0 11.12 8.87zM39 62.19c.13.01.25.01.38.01A11.938 11.938 0 0 0 45 60.8c.17-.09.34-.19.5-.29a11.878 11.878 0 0 0 0-20.35c-.16-.1-.33-.2-.5-.29a10.818 10.818 0 0 0-1.71-.75 11.76 11.76 0 0 0-3.91-.67 11.905 11.905 0 0 0-11.5 8.87 1.862 1.862 0 0 0-.07.34H0v6h27.98A11.866 11.866 0 0 0 39 62.19zm-2.885 15.765c-.16-.1-.33-.2-.5-.29a10.817 10.817 0 0 0-1.71-.75 11.76 11.76 0 0 0-3.91-.67 11.905 11.905 0 0 0-11.5 8.87 1.861 1.861 0 0 0-.07.34 11.07 11.07 0 0 0-.31 2.66 11.743 11.743 0 0 0 .38 3 3.368 3.368 0 0 0 .1.34 11.866 11.866 0 0 0 11.02 8.53c.13.01.25.01.38.01a11.937 11.937 0 0 0 5.62-1.4c.17-.09.34-.19.5-.29a11.947 11.947 0 0 0 5.36-7.185H100v-6H41.475a11.882 11.882 0 0 0-5.36-7.165z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings.5abad7e7.svg";
export { ForwardRef as ReactComponent };